import { queryOptions } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import { QUERY_CACHE } from "@/constants/constants.ts";

import { CreateSearchTidLinkedAccountTypesQueryOptions } from "./types";

export function createSearchTidLinkedAccountTypesQueryOptions({
  getTidLinkedAccountTypesFn,
}: CreateSearchTidLinkedAccountTypesQueryOptions) {
  return queryOptions({
    queryKey: [queries.GET_TID_LINKED_ACCOUNT_TYPES],
    queryFn: () => getTidLinkedAccountTypesFn(),
    staleTime: QUERY_CACHE.DEFAULT.STALE_TIME,
    gcTime: QUERY_CACHE.DEFAULT.GC_TIME,
  });
}
